import { get } from 'lodash/fp';
import { createSelector } from 'reselect';

export const getOutreachAggregateReport = get('report.outreachAggregate');

export const getOutreachAggregateReportQuery = createSelector(
  getOutreachAggregateReport,
  get('query')
);

export const getOutreachAggregateReportResult = createSelector(
  getOutreachAggregateReport,
  get('result')
);

export const getIsFetchingOutreachAggregateReport = createSelector(
  getOutreachAggregateReport,
  get('fetching')
);

export const getFetchingOutreachAggregateReportError = createSelector(
  getOutreachAggregateReport,
  get('fetchingError')
);
